import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import axios from 'axios';
import './App.css';

import ShopInfoEdit from './components/ShopInfoEdit';
import CategorySettings from './components/CategorySettings';
import Apply from './components/Apply';
import ProductList from './components/ProductList';
import ProductForm from './components/ProductForm';
import OrderList from './components/OrderList';
import PaymentSettings from './components/PaymentSettings';
import ContactSettings from './components/ContactSettings';
import MerchantInfo from './components/MerchantInfo';
import CustomCategories from './components/CustomCategories';
import CouponManage from './components/CouponManage';
import FeaturedCategories from './components/FeaturedCategories';
import FeaturedProductsManage from './components/FeaturedProductsManage';
import { CurrencyProvider } from './context/CurrencyContext';



function App() {
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
 

useEffect(() => {
    const tg = window.Telegram.WebApp;
    tg.ready();
    tg.expand();

    axios.get('/api/merchant/info', {
        headers: { 'x-telegram-init-data': tg.initData }
    })
    .then(res => {
        setMerchant(res.data);
        setLoading(false);
    })
    .catch(err => {
        console.error('后端请求失败，使用假数据', err);
        setMerchant({
            id: 1,
            name: '我的店铺（测试）',
            description: '这是测试店铺，你可以正常使用后台功能',
            address: '测试地址',
            status: 'approved',
            commission_rate: 15
        });
        setLoading(false);
    });
}, []);

  if (loading) return <div className="loading">加载中...</div>;

  return (
      <CurrencyProvider>
    <Router>
      <div className="App">
        <nav className="top-navbar">
<div className="nav-brand">
    <h2>商家后台</h2>
    <p>{merchant?.name}</p>
</div>
          <div className="nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
          <ul className={`nav-menu ${menuOpen ? 'open' : ''}`}>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>店铺信息</Link></li>
            <li><Link to="/edit-shop" onClick={() => setMenuOpen(false)}>编辑店铺信息</Link></li>
            <li><Link to="/products" onClick={() => setMenuOpen(false)}>商品管理</Link></li>
            <li><Link to="/orders" onClick={() => setMenuOpen(false)}>订单管理</Link></li>
            <li><Link to="/payment" onClick={() => setMenuOpen(false)}>支付设置</Link></li>
            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>联系方式</Link></li>
            <li><Link to="/categories" onClick={() => setMenuOpen(false)}>分类设置</Link></li>
            <li><Link to="/custom-categories" onClick={() => setMenuOpen(false)}>菜品分类</Link></li>
            <li><Link to="/coupons" onClick={() => setMenuOpen(false)}>优惠券管理</Link></li>
            <li><Link to="/featured" onClick={() => setMenuOpen(false)}>置顶分类</Link></li>
            <li><Link to="/featured-products" onClick={() => setMenuOpen(false)}>置顶商品</Link></li>
            
            
          </ul>
        </nav>
        <main className="content">
          <Routes>
            <Route path="/" element={<MerchantInfo merchant={merchant} />} />
            <Route path="/edit-shop" element={<ShopInfoEdit merchant={merchant} />} />
            <Route path="/products" element={<ProductList merchantId={merchant?.id} merchant={merchant} />} />
            <Route path="/products/new" element={<ProductForm merchantId={merchant?.id} />} />
            <Route path="/products/edit/:id" element={<ProductForm merchantId={merchant?.id} />} />
            <Route path="/orders" element={<OrderList merchantId={merchant?.id} />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/payment" element={<PaymentSettings />} />
            <Route path="/contact" element={<ContactSettings />} />
            <Route path="/categories" element={<CategorySettings />} />
            <Route path="/custom-categories" element={<CustomCategories />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/coupons" element={<CouponManage />} />
            <Route path="/featured" element={<FeaturedCategories />} />
            <Route path="/featured-products" element={<FeaturedProductsManage />} />
            
            
          </Routes>
        </main>
      </div>
    </Router>
    </CurrencyProvider>
  );
}

export default App;